var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUniversityIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.30039 6.93359H7.90039V8.36216H9.30039V6.93359Z",
    fill: "#959595"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0992 6.93359H10.6992V8.36216H12.0992V6.93359Z",
    fill: "#959595"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.30039 9.79297H7.90039V11.2215H9.30039V9.79297Z",
    fill: "#959595"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0992 9.79297H10.6992V11.2215H12.0992V9.79297Z",
    fill: "#959595"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M6.49961 12.6484H5.09961V14.077H6.49961V12.6484Z",
    fill: "#959595"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M9.30039 12.6484H7.90039V14.077H9.30039V12.6484Z",
    fill: "#959595"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0992 12.6484H10.6992V14.077H12.0992V12.6484Z",
    fill: "#959595"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M14.9 12.6484H13.5V14.077H14.9V12.6484Z",
    fill: "#959595"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M16.3 10.5056H14.2V4.79129C14.2 4.39772 13.8864 4.07701 13.5 4.07701H12.1V3.36272C12.1 2.96915 11.7864 2.64844 11.4 2.64844H8.6C8.2136 2.64844 7.9 2.96915 7.9 3.36272V4.07701H6.5C6.1136 4.07701 5.8 4.39772 5.8 4.79129V10.5056H3.7C3.3136 10.5056 3 10.8263 3 11.2199V16.9342C3 17.3292 3.3136 17.6484 3.7 17.6484H16.3C16.6864 17.6484 17 17.3292 17 16.9342V11.2199C17 10.8256 16.6864 10.5056 16.3 10.5056ZM15.6 16.2199H11.4V14.7913H8.6V16.2199H4.4V11.9342H6.5C6.8864 11.9342 7.2 11.6149 7.2 11.2199V5.50558H8.6C8.9864 5.50558 9.3 5.18629 9.3 4.79129V4.07701H10.7V4.79129C10.7 5.18629 11.0136 5.50558 11.4 5.50558H12.8V11.2199C12.8 11.6149 13.1136 11.9342 13.5 11.9342H15.6V16.2199Z",
    fill: "#959595"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUniversityIcon);
export default __webpack_public_path__ + "static/media/UniversityIcon.59c2ceae7711b31fa0559c7ef71b1762.svg";
export { ForwardRef as ReactComponent };